import { render } from "./RAIncomingMail.vue?vue&type=template&id=19051199&scoped=true"
import script from "./RAIncomingMail.vue?vue&type=script&lang=js"
export * from "./RAIncomingMail.vue?vue&type=script&lang=js"

import "./RAIncomingMail.vue?vue&type=style&index=0&id=19051199&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19051199"]])

export default __exports__